import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from './AuthContext';
import { useAcesso } from './EstadoAcesso';

/**
 * Rota de criação (novo miolo).
 *
 * Além de exigir login, confere se o acesso está ativo: com o acesso bloqueado
 * pelo administrador a pessoa não cria nada — o botão “Novo miolo” some, o menu
 * esconde o atalho e, se alguém digitar `/criar` na mão, volta para a área dela,
 * onde o aviso explica o motivo e como pedir a liberação.
 *
 * O que já existe continua acessível: abrir, editar, imprimir e excluir.
 */
export function RotaDeCriacao({ children }: { children: React.ReactNode }) {
  const { usuario, carregando } = useAuth();
  const { bloqueado, carregando: carregandoAcesso } = useAcesso();
  const local = useLocation();

  if (carregando || (usuario && carregandoAcesso)) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center gap-3 text-muted-foreground">
        <Loader2 className="size-5 animate-spin" />
        <span className="text-sm">Carregando sua área...</span>
      </div>
    );
  }

  if (!usuario) {
    // O destino guarda também a query: `?modelo=` não pode se perder no login.
    return <Navigate to="/entrar" replace state={{ de: `${local.pathname}${local.search}` }} />;
  }

  if (bloqueado) {
    return <Navigate to="/meus-miolos" replace />;
  }

  return <>{children}</>;
}
